/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { FilePdfOutlined } from '@ant-design/icons';
import {
    Button,
    Col,
    DatePicker,
    Form, Input,
    Modal,
    Row,
    Select,
    Table, Tooltip,
    notification
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { shareLicenseInfo, sharefetchLicenseList } from '../redux/LicenseManager/action';
import { getFilterCategoryListFromDatabse } from '../redux/LicenseManager/saga';
const { Option } = Select;
//const { Option } = Select;
const ShareLicenseForm = (props) => {

    const {
        onshareLicenseInfo,
        onFetchLicenseData,
        licenseData,
        licenseTotalCount,
        isLicenseLoading,
        setShowShareModel,
        showShareModel,
        shareForm,
        uniqueIdData, setuniqueIdData,
        licenseUniqueIdList, setLicenseUniqueIdList

    } = props;
    const M500_application_features = ["Solid Wire", "Horizontal Tracking", "TIG Welding"];
    const P625_application_features = ["360 Degree Welding", "Zone to Zone Ramping", "Touch and Ramp"];
    // const M500_application_features = [{ value: "Solid Wire",id:"1" }, { value: "Horizontal Tracking",id:"2" }, { value: "TIG Welding",id:"3" }];
    //const P625_application_features = [{ value: "360 Degree Welding" }, { value: "Zone to Zone Ramping" }, { value: "Touch and Ramp" }, { value: "Fronius TPSi" }];
    const application_types = [{ value: "M500" }, { value: "P625" }]
    const [fileName, setfileName] = useState("")
    const [uniqueId, setUniqueId] = useState('');
    // const [m500Setected, setM500Selected] = useState('');
    const [applicationType, setApplicationType] = useState('M500');
    const [chxList, setChxList] = useState(M500_application_features);
    const [selectedchxList, setSelectedChxList] = useState([]);
    // const [uniqueIdData, setuniqueIdData] = useState([]);
    const [email, setEmail] = useState('');
    // const [licenseUniqueIdList, setLicenseUniqueIdList] = useState([]);
    const [selectedRow, setSelectedRow] = useState([]);

    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [currentPagesize, setCurrentPagesize] = useState(10);

    const [filterCategoryList, setFilterCategoryList] = useState({
        'projectname': []
    });
    const [selectedTypeFilter, setSelectdFilterType] = useState({});
    const [searchFilterType, setSearchFilterType] = useState({});
    const [prevPageNumber, setPrevPageNumber] = useState(1);
    const [prevPagesize, setPrevPagesize] = useState(10);
    const [searchType, setSearchType] = useState({});
    const [sortingKeys, setSortingKeys] = useState(null);
    const [isSharelaoding, setIsSharelaoding] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({
        Unique_Id: '',
        Type_Of_Device: '',
        Board_Type: '',
        Location: '',
        Customer_Name: '',
        Feature_Type: ''
    });
    useEffect(() => {

        (async () => {


            var obj = {
                pageSize: currentPagesize,
                pageNumber: currentPageNumber,
                searchKey: searchCriteria,
            }
            await onFetchLicenseData(obj)


        })();

        //console.log(searchText)
    }, [searchCriteria]);

    
    const handleSearchInputChange = (fieldName, value) => {
        setSearchCriteria(prevSearchCriteria => ({
            ...prevSearchCriteria,
            [fieldName]: value
        }));
    }
    const handleTypeSearchInputChange = (fieldName, value) => {
        setSearchType(prevSearchCriteria => ({
            ...prevSearchCriteria,
            [fieldName]: value
        }));
    }
    const handleComboboxChange = async (fieldName, value) => {

        setSearchFilterType(prevSearchtype => ({
            ...prevSearchtype,
            [fieldName]: ''
        }));
        setSelectdFilterType(prevSelectedtype => ({
            ...prevSelectedtype,
            [fieldName]: value
        }));


        await handleTypeSearchInputChange(fieldName, value)
        await handleSearchInputChange(fieldName, value)
    };
    const tagRender = (props) => {
        return null
        // const { label, value, closable, onClose } = props;
        // return (
        //     <span onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
        //         style={{
        //             marginTop: 30, padding: '3px 6px', borderRadius: 3,
        //             display: 'inline-block'
        //         }}>
        //         {label}
        //         {closable && <span onClick={onClose} style={{ marginLeft: 3, cursor: 'pointer' }}>x</span>}
        //     </span>
        // );
    };

    const handleSearchComboboxChange = async (category, value) => {


        {
            //await handleSearchInputChange('Material', value)
            //setSelectedMaterial([value])
            setSearchFilterType(prevSearchtype => ({
                ...prevSearchtype,
                [category]: value
            }));
            //await handleTypeSearchInputChange('Material', value)
            await handleTypeSearchInputChange(category, value)
            await handleSearchInputChange(category, value)
            // handleSearchFilterInputChange('Material', value)
        }

    };

    const UpdateFilterCategoryList = async (fieldName, value) => {
        setFilterCategoryList(prevcategory => ({
            ...prevcategory,
            [fieldName]: value
        }));
    }

    const UpdateFilterCategory = async () => {
        const batchSize = 5; // Number of concurrent requests
        for (let i = 0; i < filtermaping.length; i += batchSize) {
            const batch = filtermaping.slice(i, i + batchSize).map(async column => {
                if (column.dataIndex !== 'edit_delete') {
                    if (!selectedTypeFilter[column.dataIndex] || selectedTypeFilter[column.dataIndex]?.length === 0) {
                        const categoryList = await getCategoryList(column.dataIndex, searchType);
                        await UpdateFilterCategoryList(column.dataIndex, categoryList);
                    }
                }
            });
            await Promise.all(batch); // Wait for the batch to finish before starting the next one
        }
    };

    useEffect(() => {
        (async () => {
           // console.log(filterCategoryList)
            await UpdateFilterCategory();
        })();
    }, [searchType]);

    const getCategoryList = async (searchKeyExist, searchkey) => {
        try {
            const object = {
                header: searchKeyExist,
                searchKey: searchkey
            }
            //  console.log('Search key', object)
            //return;
            const response = await getFilterCategoryListFromDatabse(object);
          //  console.log('Search key', response)
            if (response) {

                return response;
            }
        } catch (error) {
            notification.error({
                message: 'Something went wrong. ' + searchKeyExist,
            });
            return []
        }
    };


    // const update = async () => {

    //     setLicenseUniqueIdList([])
    //     await onFetchLicenseData();

    // }
    // useEffect(() => {
    //     if (!isLicenseLoading)
    //         setuniqueIdData([...licenseData])

    // }, [isLicenseLoading])


    useEffect(() => {

        if (licenseUniqueIdList.length == 0 && uniqueIdData) {
            const a = uniqueIdData.map((item, i) => {
                return item.Unique_Id
            }
            )
            const uniqueArray = a.filter(function (item, pos) {
                return a.indexOf(item) == pos;
            })
            // if (licenseUniqueIdList && licenseUniqueIdList.length == 0)
            setLicenseUniqueIdList([...uniqueArray]);
        }

    }, [uniqueIdData])


    const filtermaping = [
        {
            title: 'User Identifier',
            dataIndex: 'License_File_Name',
            key: 'License_File_Name',
        },
        {
            title: 'Unique Id',
            dataIndex: 'Unique_Id',
            key: 'Unique_Id',
            width: '220px',

        },
        {
            title: 'Machine Type',
            dataIndex: 'Type_Of_Device',
            key: 'Type_Of_Device',
            align: 'center',

        },
        {
            title: 'Board Type',
            dataIndex: 'Board_Type',
            key: 'Board_Type',
            align: 'center',

        },
        {
            title: 'Feature Type',
            dataIndex: 'Feature_Type',
            key: 'Feature_Type',
            align: 'center',
            width: '160px',

        },
        {
            title: 'Customer Name',
            dataIndex: 'Customer_Name',
            key: 'Customer_Name',
            align: 'center',

        },
        {
            title: 'Machine Serial Number',
            dataIndex: 'Serial_Number',
            key: 'Serial_Number',
            width: '160px',
            align: 'center',

        },
        {
            title: 'Contractor',
            dataIndex: 'Contractor',
            key: 'Contractor',
            align: 'center',

        },
        // {
        //     title: 'Create Date',
        //     dataIndex: 'File_Creation_Date',
        //     key: 'File_Creation_Date',
        //     align: 'center',

        // },

    ]

    const GetFilterCategroyInputFeild = (fieldName,placeHolder) => {
        return (
            <div className='searchDashboardSpares'>
                <div className='maintenance-select1'>
                    <Select
                        className='maintenance-select1'
                        placeholder={`Select ${placeHolder}`}
                        showSearch
                        allowClear
                        mode="multiple"
                        tagRender={tagRender}


                        //loading={isUserListLoading}
                        style={{
                            height: '35px',
                            position: 'relative',
                            top: '0px',
                            width: '100%'
                            
                        }}
                        //optionFilterProp="children"
                        optionFilterProp={false}
                        onChange={(value) => handleComboboxChange(fieldName, value)}
                        // onFocus={onGetAllUsers}
                        // onDropdownVisibleChange={handleDropdownVisibleChange}
                        onSearch={(value) => handleSearchComboboxChange(fieldName, value)}
                        searchValue={searchFilterType[fieldName]}
                        //value={matrialSearchType == '' ? selectedMaterial : matrialSearchType}
                        value={selectedTypeFilter[fieldName]}

                    // disabled={disableTypes}
                    >
                        {Object.keys(filterCategoryList).length > 0 && filterCategoryList[fieldName] &&
                            filterCategoryList[fieldName]
                                //.sort((a, b) => a[column.dataIndex].localeCompare(b[column.dataIndex])) // Sort by category
                                .map((item, i) => (
                                    <Option key={i} value={item[fieldName]}> {/* Use item.category as value */}
                                        {item[fieldName]}
                                    </Option>
                                ))
                        }
                    </Select>
                    <div className="selected-tags">
                        {selectedTypeFilter && selectedTypeFilter[fieldName]?.length == 0 && searchFilterType[fieldName] != '' &&
                            <div key={0} className='selected-tag'>
                                {searchFilterType[fieldName]}
                                <span
                                    className='remove-tag'
                                    onClick={() => {


                                        handleSearchComboboxChange(fieldName, '')
                                        //setSelectedMaterial(newSelectedMaterials);
                                    }}
                                >
                                    X
                                </span>
                            </div>
                        }
                        {searchFilterType[fieldName] === '' && selectedTypeFilter[fieldName]?.length > 0 && selectedTypeFilter[fieldName].map((value, index) => (
                            <div key={index} className='selected-tag'>
                                {value}
                                <span
                                    className='remove-tag'
                                    onClick={() => {

                                        const newSelectedMaterials = selectedTypeFilter[fieldName].filter(item => item !== value);
                                        //handleMaterialComboboxChange(newSelectedMaterials)
                                        handleComboboxChange(fieldName, newSelectedMaterials)
                                        //setSelectedMaterial(newSelectedMaterials);
                                    }}
                                >
                                    X
                                </span>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        )
    }
    const getFilterDateSearchInputFeild = (fieldName) => {
        return (
            <div className='date-picker'>
                <DatePicker
                    allowClear
                    style={{ height: '30px', border: 'line', }}
                    format="DD-MM-YYYY"
                    placeholder='Search Date'
                    onChange={date => handleComboboxChange(fieldName, moment(date).format('YYYY-MM-DD'))}
                    bordered
                />
            </div>
        )
    }
    const columns = [

        {
            // title: 'User Identifier',
            dataIndex: 'License_File_Name',
            key: 'License_File_Name',
            filterSearch: true,
            width: '200px',
            align: 'left',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', textAlign: 'left', paddingLeft: '20%' }}>
                        User Identifier
                    </div>
                    {GetFilterCategroyInputFeild('License_File_Name','User Identifier')}
                </div>
            ),
            // sorter: (a, b) => (a.License_File_Name.localeCompare(b.License_File_Name)),
            // render: (text) => <a style={{ paddingLeft: '2px' }}>{text}</a>,
        },
        {
            // title: 'Unique Id',
            dataIndex: 'Unique_Id',
            key: 'Unique_Id',
            width: '260px',
            //sorter: (a, b) => a.Unique_Id.localeCompare(b.Unique_Id),
            //render: (text) => <a>{text}</a>,

            align: 'center',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', textAlign: 'left', paddingLeft: '25%' }}>
                        Unique ID
                    </div>
                    {GetFilterCategroyInputFeild('Unique_Id','Unique ID')}
                </div>
            ),
        },
        {
            //title: 'Machine Type',
            dataIndex: 'Type_Of_Device',
            key: 'Type_Of_Device',
            align: 'center',
            width: '200px',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', textAlign: 'center', }}>
                        Machine Type
                    </div>
                    {GetFilterCategroyInputFeild('Type_Of_Device' ,'Machine Type')}
                </div>
            ),
        },
        {
            title: 'Board Type',
            dataIndex: 'Board_Type',
            key: 'Board_Type',
            align: 'left',
            width: '200px',
            //sorter: (a, b) => (a.Board_Type.localeCompare(b.Board_Type))
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', textAlign: 'left', paddingLeft: '25%' }}>
                        Board Type
                    </div>
                    {GetFilterCategroyInputFeild('Board_Type' ,  'Board Type')}
                </div>
            ),
        },
        {
            title: 'Feature Type',
            dataIndex: 'Feature_Type',
            key: 'Feature_Type',
            align: 'left',
            width: '200px',
            render: (text) => <div style={{ display: 'flex', placeContent: 'center' }}>{text ? text : '-'}</div>,
            // sorter: (a, b) => (a.Customer_Name.localeCompare(b.Customer_Name))
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', textAlign: 'left', paddingLeft: '20%' }}>
                        Feature Type
                    </div>
                    {GetFilterCategroyInputFeild('Feature_Type','Feature Type')}
                </div>
            ),
            // sorter: (a, b) => (a.Feature_Type.localeCompare(b.Feature_Type))
        },
        {
            title: 'Customer Name',
            dataIndex: 'Customer_Name',
            key: 'Customer_Name',
            align: 'center',
            width: '200px',
            render: (text) => <div style={{ display: 'flex', placeContent: 'center' }}>{text ? text : '-'}</div>,
            // sorter: (a, b) => (a.Customer_Name.localeCompare(b.Customer_Name))
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', }}>
                        Customer Name
                    </div>
                    {GetFilterCategroyInputFeild('Customer_Name','Customer')}
                </div>
            ),
        },
        {
            // title: 'Serial Number',
            dataIndex: 'Serial No.',
            key: 'Serial_Number',
            width: '200px',
            align: 'center',
            render: (text) => <div style={{ placeContent: 'center' }}>{text ? text : '-'}</div>,
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', }}>
                        Serial Number
                    </div>
                    {GetFilterCategroyInputFeild('Serial_Number','Serial No.')}
                </div>
            ),
        },
        {
            title: 'Contractor',
            dataIndex: 'Contractor',
            key: 'Contractor',
            align: 'center',
            width: '200px',
            render: (text) => <div style={{ placeContent: 'center' }}>{text ? text : '-'}</div>,
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', }}>
                        Contractor
                    </div>
                    {GetFilterCategroyInputFeild('Contractor','Contractor')}
                </div>
            ),
        },
        {
            title: 'Create Date',
            dataIndex: 'File_Creation_Date',
            key: 'File_Creation_Date',
            align: 'center',
            width: '200px',
            render: (text) => {
                return (
                    <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
                );
            },
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', }}>
                        Create Date
                    </div>
                    {getFilterDateSearchInputFeild('File_Creation_Date')}
                </div>
            ),
            // sorter: (a, b) => moment(a.File_Creation_Date).valueOf() - moment(b.File_Creation_Date).valueOf()
        },
        {
            // title: 'Expiration Date',
            dataIndex: 'Expiration_Date',
            key: 'Expiration_Date',
            align: 'center',
            width: '200px',
            render: (text) => {
                return (
                    <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
                );
            },
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', }}>
                        Expiration Date
                    </div>
                    {getFilterDateSearchInputFeild('Expiration_Date')}
                </div>
            ),
            // sorter: (a, b) => a.Expiration_Date - b.Expiration_Date,
            // sorter: (a, b) => moment(a.Expiration_Date).valueOf() - moment(b.Expiration_Date).valueOf()
        },

        {
            title: 'Link',
            dataIndex: 'File_Link',
            key: 'File_Link',
            align: 'center',
            //fixed: 'right',
            width: '150px',
            render: (text, record) => {
                return (
                    <>
                        <Tooltip title="Download license file" >

                            <Button href={record.File_Link} className='p-0 border-0' size='small' target='_blank'>
                                <FilePdfOutlined className='pdfIconRed' />
                            </Button>

                        </Tooltip>
                    </>
                )
            }
        },
    ];
    useEffect(() => {
        if (applicationType === 'M500') {
            setChxList(M500_application_features)
        }
        else {
            setChxList(P625_application_features)
        }

    }, [applicationType])

    // useEffect(() => {
    //     if (licenseUniqueIdList.length > 0) {
    //         var obj = {
    //             // pageSize: 10,
    //             //pageNumber: 1,
    //             searchKey: searchText
    //         }


    //         onFetchLicenseData(obj)

    //     }
    // }, [searchText]);
    // useEffect(() => {
    //     if (!showShareModel) {
    //         setuniqueIdData([])

    //         shareForm.resetFields();
    //         setSearchText('')
    //         setLicenseUniqueIdList([])
    //         //console.log(" handle false")
    //     }
    //     else {
    //         update()
    //     }

    // }, [showShareModel])
    const validateEmail = (email) => {
        const regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        return regexp.test(email);
    }
    // const [shareForm] = Form.useForm()

    const handleOk = async () => {

        try {



            shareForm
                .validateFields()
                .then(async(data) => {

                    if (!email && !selectedRow) {
                        notification.warning({
                            message: 'Select All Required Fields to proceed!'
                        });
                    } else if (!email|| !validateEmail(email)) {
                        notification.warning({
                            message: 'please enter valid mail id to proceed!'
                        });
                    } else if (!selectedRow || selectedRow.length == 0) {
                        notification.warning({
                            message: 'Select Row  to proceed!'
                        });
                    }
                    else {
                        setIsSharelaoding(true)
                        //console.log(selectedRow)
                        var obj = {
                            "emailAddress":email,
                            "uniqueId": data.uniqueId,
                            "selectedRow": selectedRow
                        }
                      await  onshareLicenseInfo(obj)
                      setIsSharelaoding(false)
                           handleCancel();
                    }

                });
        } catch (error) {
            notification.destroy();
            notification.error({
                message: error.message,
            });
        }

    };
    const handleCancel = async () => {
        // setSearchText('')
        shareForm.resetFields();

        setLicenseUniqueIdList([])
        setuniqueIdData([])

        // var obj = {
        //     //   pageSize: 10,
        //     //  pageNumber: 1,
        //     searchKey: ''
        // }

        // await onFetchLicenseData(obj)
        setShowShareModel(false);

    };


    const onChangeUniqueid = async (value) => {

        // if (value) {
        //     setSearchText(value);
        // }
        // else
        //     setSearchText('')
    }


    return (

        <div>
            <div>

                <Modal
                    width="100%"
                    height='100%'
                   // className="pipeline-modal trackrecord-modal"
                    title="Share License"
                    centered
                    visible={showShareModel}
                    footer={
                        <div 
                            style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center', 
                                width: '100%', 
                                padding: '10px 20px' 
                            }}
                        >
                            {/* Email Input Section */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexGrow: 1 }}>
                                <Form.Item 
                                    label="Email" 
                                    name="email" 
                                    required 
                                    style={{ marginBottom: 0, whiteSpace: 'nowrap' }}
                                >
                                    <Input
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                        size="large"
                                        placeholder="Enter emails followed by comma (,)"
                                        style={{ width: '350px' }} // Adjust width as needed
                                    />
                                </Form.Item>
                                <span style={{ fontSize: '12px', color: 'gray' }}>
                                    eg: 1234@mail.com, 234@email.com
                                </span>
                            </div>
                
                            {/* Buttons Section */}
                            <div style={{ textAlign: 'right' }}>
                                <Button key="cancel" onClick={handleCancel}>
                                    Cancel
                                </Button>
                                <Button 
                                    key="apply" 
                                    type="primary"
                                    onClick={handleOk}
                                    loading ={isSharelaoding}
                                    disabled={(email.length > 0 && selectedRow.length > 0) ? false : true}
                                    style={{
                                        backgroundColor: (email.length > 0 && selectedRow.length > 0) ? "#ef314c" : "gray",
                                        marginLeft: '10px',
                                    }}
                                >
                                    Share
                                </Button>
                            </div>
                        </div>
                    }
                >
                    {/* <div>
                        <Form
                            form={shareForm}
                            name="basic"
                            layout="vertical"
                            autoComplete="off"
                        >
                            <Row gutter={16}>
                                <Col lg={8} style={{ marginBottom: '10px' }}>
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        required
                                        style={{ marginBottom: 0 }}
                                    // rules={[
                                    //     {
                                    //         required: true,
                                    //         message: 'Please input your registered email!',
                                    //     },
                                    //     {
                                    //         pattern:EMAIL_PATTERN,

                                    //         message: 'Provide a valid email.',
                                    //     }
                                    // ]}
                                    >
                                        <Input
                                            // disabled
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                            size="large"
                                            placeholder='Enter emails followed by comma (,)'
                                        // onKeyDown={onKeyDown}
                                        />

                                    </Form.Item>
                                    <span style={{ fontSize: '12px', position: 'relative', left: '10px', color: 'gray' }}>eg: 1234@mail.com, 234@email.com</span>
                                </Col>
                                <Col lg={8} style={{ marginBottom: '10px' }}>
                                    <Form.Item
                                        label="Unique Id"
                                        name="uniqueId"

                                    >
                                        <Select
                                            className='client-select'
                                            placeholder='Select Unique Id'
                                            showSearch
                                            allowClear
                                            optionFilterProp="children"
                                            onChange={onChangeUniqueid}
                                            style={{
                                                height: '30px',
                                                position: 'relative',
                                                width: '250px',
                                            }}
                                        >
                                            {licenseUniqueIdList && licenseUniqueIdList.map((item, i) =>

                                                <Option key={i} value={item}>{item}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>

                            </Row>
                        </Form>
                    </div> */}
                    <div className='flex-auto addTeamDetailsLicense'>
                        <Table columns={columns}
                            dataSource={[...licenseData]}
                            className="h-100 pipeline-table equip_table equipPaginationTable  licenseSort"
                            scroll={{ y: 'calc(100vh - 240px)' }}
                            //scroll={{ y: 'calc(100vh - 250px)' }}
                            // scroll={{ y: 'calc(100vh - 320px)' ,x:1600}}
                            rowKey={(record) => record.id}


                            rowSelection={{

                                // onChange: (selectedRowKeys, selectedRows) => {
                                //     console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                                // },
                                onSelect: (record, selected, selectedRows) => {
                                    //  const   data = selectedRows.filter(function( element ) {
                                    //         return element !== undefined;
                                    //      });
                                    //     console.log(selected);
                                    //     console.log(data);

                                    //     const array3 = [...selectedRow, ...data]
                                    //      console.log(array3);
                                    setSelectedRow(selectedRows);

                                    //console.log(selectedRow);
                                },
                                onSelectAll: (selected, selectedRows, changeRows) => {

                                    // const array3 = [...selectedRow, ...selectedRows]
                                    setSelectedRow(selectedRows);
                                    //console.log(selectedRow);
                                },
                            }}
                            // pagination={licenseTotalCount > 10 ? {
                            //     position: ['bottomRight'],
                            //     //className: 'fixed-pagination2',
                            //     showSizeChanger: true,
                            //     total: licenseTotalCount,
                            //     defaultPageSize: 10,
                            //     defaultCurrent: 1,

                            //     //  onChange: async (pageNumber, pageSize,selectedRows) => {
                            //     // console.log(licenseTotalCount, pageNumber, pageSize)
                            //     // var obj = {
                            //     //     pageSize: pageSize,
                            //     //     pageNumber: pageNumber
                            //     // }
                            //     // await onFetchLicenseData(obj)
                            //     //   selectedRows =selectedRow
                            //     //  console.log(selectedRows);


                            //     //}
                            // }
                            //     : false
                            // }

                            pagination={
                                licenseTotalCount > 10 ? {
                                    position: ['bottomRight'],
                                    className: 'License-fixed-pagination',
                                    showSizeChanger: true,
                                    total: licenseTotalCount,
                                    defaultPageSize: 10,
                                    defaultCurrent: 1,

                                    onChange: async (pageNumber, pageSize) => {
                                        // console.log(licenseTotalCount, pageNumber, pageSize)
                                        setCurrentPageNumber(pageNumber);
                                        setCurrentPagesize(pageSize);
                                        var obj = {
                                            pageSize: pageSize,
                                            pageNumber: pageNumber,
                                            searchKey: searchCriteria,
                                            sort: sortingKeys
                                        }
                                        await onFetchLicenseData(obj)

                                    }
                                }
                                    : false
                            }

                            loading={isLicenseLoading}
                        />

                    </div>
                </Modal >
            </div>
        </div>
    );
};

const mapStateToProps = ({ licenseMangerReducer }) => {
    const licenseData = get(licenseMangerReducer, 'shareList', []);
    // let licenseUniqueIdList = get(licenseMangerReducer, 'LicenseData', []);
    // if (licenseData) {
    //     const a = licenseData.map((item, i) => {
    //         return item.Unique_Id
    //     }
    //     )
    //     const uniqueArray = a.filter(function (item, pos) {
    //         return a.indexOf(item) == pos;
    //     })
    //     licenseUniqueIdList = uniqueArray;
    // }


    const isLicenseLoading = get(licenseMangerReducer, 'isLicenseLoading', false);
    //const isUploadLicsense = get(licenseMangerReducer, 'isUploadLicsense', false);
    const licenseTotalCount = get(licenseMangerReducer, 'LicenseListCount', null);
    return {
        licenseData,
        isLicenseLoading,
        // isUploadLicsense,
        licenseTotalCount
    }
}



const mapDispatchToProps = {
    onshareLicenseInfo: shareLicenseInfo,
    onFetchLicenseData: sharefetchLicenseList,

};

export default connect(mapStateToProps, mapDispatchToProps)(ShareLicenseForm);

